import { useEffect, useReducer, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { type Feature, featureEntries, isFeatureEnabled, setFeatureEnabled } from "../features";
import styles from "./Features.module.css";

export function Features() {
    const [, forceUpdate] = useReducer((x: number) => x + 1, 0);
    const navigate = useNavigate();
    const backRef = useRef<HTMLButtonElement>(null);
    const entries = featureEntries();

    useEffect(() => {
        const opener = document.activeElement as HTMLElement | null;
        backRef.current?.focus();
        return () => {
            const gear = document.getElementById("feature-flags-button");
            (gear ?? opener)?.focus?.();
        };
    }, []);

    function handleToggle(feature: Feature, checked: boolean) {
        setFeatureEnabled(feature, checked);
        forceUpdate();
    }

    return (
        <div className={styles.container}>
            <button type="button" onClick={() => navigate(-1)} className={styles.backLink} ref={backRef}>
                ← Back
            </button>
            <h2 className={styles.title}>Feature flags</h2>
            <p className={styles.subtitle}>
                Toggle experimental features. Settings are stored in your browser and apply only to you.
            </p>
            {entries.length > 0 ? (
                <ul className={styles.list}>
                    {entries.map(([key, description]) => (
                        <li key={key} className={styles.item}>
                            <label className={styles.toggle}>
                                <input
                                    type="checkbox"
                                    checked={isFeatureEnabled(key)}
                                    onChange={(e) => handleToggle(key, e.target.checked)}
                                />
                                <span className={styles.slider} />
                            </label>
                            <div>
                                <span className={styles.label}>{description}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            ) : (
                <p className={styles.description}>No experimental features are available right now.</p>
            )}
        </div>
    );
}
